var _metadata, _defs, _g, _g2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAkLogo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 695,
    height: 240,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _metadata || (_metadata = /*#__PURE__*/React.createElement("metadata", {
    id: "metadata8"
  }, "image/svg+xml")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "clipPath30"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m-159.927292,805.123834l841.89,0l0,-595.28l-841.89,0l0,595.28z",
    id: "path28"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("title", null, "background"), /*#__PURE__*/React.createElement("rect", {
    fill: "none",
    id: "canvas_background",
    height: 242,
    width: 697,
    y: -1,
    x: -1
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("title", null, "Layer 1"), /*#__PURE__*/React.createElement("g", {
    id: "g10",
    transform: "matrix(1.3333333,0,0,-1.3333333,0,793.70667) "
  }, /*#__PURE__*/React.createElement("g", {
    id: "g12"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#295283",
    fillRule: "nonzero",
    d: "m69.810013,558.414024l16.956,29.366l16.953,-29.366l-33.909,0z",
    id: "path14"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g16"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#295283",
    fillRule: "nonzero",
    d: "m103.719223,456.554741l-16.956,-29.367l-16.953,29.367l33.909,0z",
    id: "path18"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g20"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#295283",
    fillRule: "nonzero",
    d: "m7.500015,533.065727l37.085,-27.058l-37.085,-27.058l0,54.116z",
    id: "path22"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g24"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g26",
    clipPath: "url(#clipPath30)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g32"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#4081cb",
    fillRule: "nonzero",
    d: "m109.789719,507.484337l30.994,17.893c-7.508,22.744 -28.919,39.164 -54.177,39.164c-31.513,0 -57.057,-25.545 -57.057,-57.058c0,-31.512 25.544,-57.057 57.057,-57.057c25.26,0 46.669,16.42 54.177,39.164l-30.994,17.894z",
    id: "path34"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g36"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    fillRule: "nonzero",
    d: "m103.284805,545.56884c-6.199,0 -11.397,-4.242 -12.884,-9.977l-15.309,0l-6.143,0l-2.836,0l-6.145,0l-6.424,0l0,-6.308l6.424,0l0,-9.083l6.145,0l0,9.083l2.836,0l0,-6.055l6.143,0l0,6.055l15.211,0c1.349,-5.931 6.643,-10.362 12.982,-10.362c7.358,0 13.322,5.966 13.322,13.323c0,7.359 -5.964,13.324 -13.322,13.324",
    id: "path38"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g40"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#295283",
    fillRule: "nonzero",
    d: "m96.617813,532.245323c0,-3.681 2.987,-6.665 6.667,-6.665c3.682,0 6.667,2.984 6.667,6.665c0,3.682 -2.985,6.666 -6.667,6.666c-3.68,0 -6.667,-2.984 -6.667,-6.666",
    id: "path42"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g44"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#295283",
    fillRule: "nonzero",
    d: "m56.812012,532.43792c0,-1.859 -1.507,-3.367 -3.367,-3.367c-1.859,0 -3.365,1.508 -3.365,3.367c0,1.859 1.506,3.366 3.365,3.366c1.86,0 3.367,-1.507 3.367,-3.366",
    id: "path46"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g48"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#295283",
    fillRule: "nonzero",
    d: "m193.89772,504.094048l-2.241,6.24c-0.528,1.611 -1.304,4.028 -2.329,7.251l-1.187,3.604c-0.176,-0.791 -0.637,-2.249 -1.384,-4.373c-0.747,-2.124 -1.546,-4.284 -2.395,-6.482l-2.329,-6.24l11.865,0zm-12.129,34.849l12.7,0l21.402,-57.701l-13.931,0l-4.263,11.866l-19.424,0l-4.306,-11.866l-13.711,0l21.533,57.701z",
    id: "path50"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g52"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#295283",
    fillRule: "nonzero",
    d: "m256.698013,521.847923l0,-40.605l-10.415,0l-0.835,4.57c-1.436,-1.934 -3.216,-3.377 -5.34,-4.329c-2.124,-0.951 -4.489,-1.428 -7.097,-1.428c-4.863,0 -8.613,1.443 -11.25,4.329c-2.637,2.885 -3.955,6.818 -3.955,11.799l0,25.664l12.612,0l0,-23.774c0,-2.52 0.586,-4.336 1.758,-5.45c1.171,-1.113 2.872,-1.67 5.098,-1.67c2.168,0 3.845,0.674 5.031,2.022c1.187,1.347 1.781,3.164 1.781,5.449l0,23.423l12.612,0z",
    id: "path54"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g56"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#295283",
    fillRule: "nonzero",
    d: "m288.163895,511.47683l-7.646,0l0,-30.234l-12.569,0l0,30.234l-7.471,0l0,10.371l7.471,0l0,10.503l12.569,0l0,-10.503l7.646,0l0,-10.371z",
    id: "path58"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g60"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#295283",
    fillRule: "nonzero",
    d: "m292.428513,542.985649l12.568,0l0,-25.093c1.202,1.67 2.857,2.981 4.966,3.933c2.11,0.952 4.424,1.429 6.944,1.429c4.863,0 8.598,-1.51 11.206,-4.527c2.607,-3.017 3.911,-7.119 3.911,-12.305l0,-25.18l-12.525,0l0,22.236c0,3.369 -0.747,5.603 -2.241,6.702c-1.494,1.098 -3.032,1.648 -4.614,1.648c-1.787,0 -3.523,-0.506 -5.207,-1.516c-1.686,-1.011 -2.528,-3.172 -2.528,-6.482l0,-22.588l-12.48,0l0,61.743z",
    id: "path62"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g64"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#4081cb",
    fillRule: "nonzero",
    d: "m362.523331,502.731743l-8.569,-10.679l0,-11.074l-13.14,0l0,57.964l13.14,0l0,-26.455l20.874,26.455l16.391,0l-19.775,-24.829l19.863,-32.871l-15.732,0l-13.052,21.489z",
    id: "path66"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g68"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#4081cb",
    fillRule: "nonzero",
    d: "m418.467606,506.335228c-0.06,2.05 -0.843,3.676 -2.352,4.878c-1.508,1.201 -3.42,1.802 -5.734,1.802c-2.345,0 -4.27,-0.601 -5.779,-1.802c-1.509,-1.202 -2.322,-2.828 -2.439,-4.878l16.304,0zm6.064,-22.346c-3.751,-2.622 -8.233,-3.933 -13.447,-3.933c-4.248,0 -7.998,0.901 -11.25,2.702c-3.252,1.802 -5.772,4.336 -7.558,7.603c-1.788,3.266 -2.681,7.038 -2.681,11.316c0,4.306 0.893,8.1 2.681,11.382c1.786,3.28 4.306,5.8 7.558,7.558c3.252,1.758 6.914,2.637 10.987,2.637c4.013,0 7.58,-0.835 10.7,-2.505c3.12,-1.67 5.537,-3.992 7.251,-6.965c1.714,-2.974 2.571,-6.35 2.571,-10.13c0,-2.109 -0.176,-3.94 -0.527,-5.493l-28.828,0c0.116,-2.402 1.002,-4.322 2.658,-5.757c1.655,-1.435 3.801,-2.153 6.438,-2.153c1.992,0 3.706,0.374 5.142,1.121c1.434,0.747 2.417,1.72 2.944,2.922l12.261,0c-0.851,-4.248 -3.15,-7.684 -6.9,-10.305",
    id: "path70"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g72"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#4081cb",
    fillRule: "nonzero",
    d: "m478.103287,521.847923l-18.809,-47.197c-1.026,-2.461 -2.146,-4.599 -3.362,-6.416c-1.216,-1.817 -3.025,-3.421 -5.427,-4.812c-2.402,-1.391 -5.434,-2.088 -9.096,-2.088c-2.461,0 -5.23,0.337 -8.306,1.011l0.176,10.239c2.225,-0.41 4.189,-0.615 5.888,-0.615c2.05,0 3.669,0.286 4.856,0.857c1.186,0.571 2.065,1.274 2.637,2.109c0.571,0.835 1.091,1.912 1.56,3.23l0.747,1.802l-17.358,41.88l13.579,0l9.536,-26.587l10.064,26.587l13.315,0z",
    id: "path74"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g76"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#4081cb",
    fillRule: "nonzero",
    d: "m484.235184,483.703423c-3.268,2.432 -5.076,5.757 -5.428,9.976l12.393,0c0.058,-1.378 0.615,-2.447 1.67,-3.208c1.054,-0.763 2.387,-1.143 3.999,-1.143c1.435,0 2.578,0.271 3.428,0.813c0.849,0.542 1.274,1.355 1.274,2.439c0,0.967 -0.329,1.677 -0.988,2.131c-0.66,0.454 -1.561,0.798 -2.703,1.033l-6.504,1.626c-7.735,1.846 -11.602,5.917 -11.602,12.217c0,4.072 1.561,7.367 4.681,9.887c3.12,2.52 7.199,3.78 12.238,3.78c4.98,0 9.016,-1.231 12.107,-3.692c3.091,-2.461 4.695,-5.698 4.812,-9.712l-12.217,0c-0.058,1.202 -0.542,2.161 -1.45,2.879c-0.908,0.718 -2.08,1.077 -3.516,1.077c-1.259,0 -2.248,-0.264 -2.965,-0.791c-0.719,-0.528 -1.078,-1.275 -1.078,-2.242c0,-0.966 0.301,-1.633 0.902,-1.999c0.599,-0.367 1.618,-0.725 3.053,-1.077l7.559,-1.802c3.662,-0.85 6.351,-2.336 8.064,-4.46c1.714,-2.125 2.571,-4.651 2.571,-7.581c0,-4.19 -1.589,-7.536 -4.768,-10.041c-3.179,-2.505 -7.478,-3.757 -12.898,-3.757c-5.156,0 -9.367,1.215 -12.634,3.647",
    id: "path78"
  }))))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAkLogo);
export default __webpack_public_path__ + "static/media/ak-logo.c63620477f6d2dc470bc337992b2f97d.svg";
export { ForwardRef as ReactComponent };